import { useDispatch, useSelector } from 'react-redux';
import { useGetCablesQuery } from '../../utils/callApis';
import { Box } from '@material-ui/core';
import _ from 'lodash';
import Picker from './Picker';
import ColorPicker from './ColorPicker';
import allActions from '../../actions/product_builder';
import CircularProgress from '@mui/material/CircularProgress';
import typography from '../../styles/typography.module.css';
import layout from '../../styles/layout.module.css';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
export const CableSection = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { data: cableOption, isLoading, isSuccess, isError, error } = useGetCablesQuery();

    let content;
    let actionCreator = allActions.cableActions;
    const currentTypeOption = useSelector(
        (state) => state.rootReducer.currentCableOption.activeCableType
    );
    const currentColorOption = useSelector(
        (state) => state.rootReducer.currentCableOption.activeCableColor
    );
    const currentLengthOption = useSelector(
        (state) => state.rootReducer.currentCableOption.activeCableLength
    );

    // Keep Redux updates out of render; adjust cable length and active cable after data/selection changes.
    useEffect(() => {
        if (
            !isSuccess ||
            !cableOption ||
            currentTypeOption === undefined ||
            currentColorOption === undefined ||
            currentLengthOption === undefined
        ) {
            return;
        }

        // Recompute type/color/length lists based on current selections
        const generateOptions = (data) => {
            const list = [];
            for (const [key] of Object.entries(data)) {
                list.push(key);
            }
            return list.sort((a, b) => b - a);
        };

        const typeOptions = generateOptions(cableOption).sort((a, b) => b.localeCompare(a));

        let colorTypes;
        {
            let index;
            if (!currentTypeOption.includes(' Cables')) {
                index = typeOptions.indexOf(currentTypeOption + ' Cables');
            } else {
                index = typeOptions.indexOf(currentTypeOption);
            }
            colorTypes = cableOption[typeOptions[index]] || cableOption[typeOptions[0]];
        }

        const colorOptions = generateOptions(colorTypes[0]);

        let lengthList;
        if (currentColorOption !== undefined && colorOptions.includes(currentColorOption)) {
            const idx = colorOptions.indexOf(currentColorOption);
            lengthList = colorTypes[0][colorOptions[idx]];
        } else {
            const fallbackIndex = colorOptions.length > 0 ? 0 : -1;
            lengthList =
                fallbackIndex >= 0 && colorTypes[0][colorOptions[fallbackIndex]]
                    ? colorTypes[0][colorOptions[fallbackIndex]]
                    : [];
        }

        const lengthOptions = new Set();
        (lengthList || []).forEach((parm) => {
            if (parm && parm.cableLength) {
                lengthOptions.add(parm.cableLength);
            }
        });

        const availableLengths = [...lengthOptions];
        if (availableLengths.length === 0) {
            return;
        }

        if (!_.includes(availableLengths, currentLengthOption)) {
            dispatch(allActions.cableActions.setActiveCableLength(availableLengths[0]));
        }

        _.forEach(lengthList || [], function (element) {
            if (
                element &&
                element.cableLength &&
                element.cableLength.includes(currentLengthOption)
            ) {
                dispatch(allActions.cableActions.setActiveCable(element));
            }
        });
    }, [
        isSuccess,
        cableOption,
        currentTypeOption,
        currentColorOption,
        currentLengthOption,
        dispatch
    ]);

    if (isLoading) {
        content = (
            <Box className={layout.loaderContainer}>
                <CircularProgress />
            </Box>
        );
    } else if (isSuccess) {
        let generateOptions = (cableOption) => {
            let list = [];
            for (const [key] of Object.entries(cableOption)) {
                list.push(key);
            }
            return list.sort((a, b) => b - a);
        };

        let generateImageOptions = (cableOption) => {
            let list = [];
            for (const [key, value] of Object.entries(cableOption)) {
                let option = value[0];
                list.push({ color: key, icon: option.iconImage });
            }
            return list;
        };

        let typeOptions = generateOptions(cableOption).sort((a, b) => b.localeCompare(a));
        let colorTypes;
        if (currentTypeOption !== undefined) {
            let index;
            if (!currentTypeOption.includes(' Cables')) {
                index = typeOptions.indexOf(currentTypeOption + ' Cables');
            } else {
                index = typeOptions.indexOf(currentTypeOption);
            }
            colorTypes = cableOption[typeOptions[index]];
        } else {
            colorTypes = cableOption[typeOptions[0]];
        }

        let colorOptions = generateOptions(colorTypes[0]);
        let colorOptionsIMG = generateImageOptions(colorTypes[0]);
        let lengthList;
        if (currentColorOption !== undefined && colorOptions.includes(currentColorOption)) {
            let index = colorOptions.indexOf(currentColorOption);
            lengthList = colorTypes[0][colorOptions[index]];
        } else {
            const fallbackIndex = colorOptions.length > 0 ? 0 : -1;
            lengthList =
                fallbackIndex >= 0 && colorTypes[0][colorOptions[fallbackIndex]]
                    ? colorTypes[0][colorOptions[fallbackIndex]]
                    : [];
        }

        let lengthOptions = new Set();
        (lengthList || []).forEach((parm) => {
            if (parm && parm.cableLength) {
                lengthOptions.add(parm.cableLength);
            }
        });
        let colorTitle = t('cable.color');
        if (currentColorOption !== undefined) {
            colorTitle = currentColorOption;
        }

        content = (
            <>
                <Box className={layout.subSectionContainer}>
                    <h4 className={typography.headerTitle}>{t('cable.socket_type')}</h4>
                    <Picker
                        data={cableOption}
                        options={typeOptions}
                        action={actionCreator.setActiveCableType}
                        currentOption={currentTypeOption}
                    />
                </Box>
                <Box className={layout.subSectionContainer}>
                    <h4 className={typography.headerTitle}>{colorTitle}</h4>
                    <ColorPicker
                        data={colorTypes[0]}
                        options={colorOptionsIMG}
                        action={actionCreator.setActiveCableColor}
                        currentOption={currentColorOption}
                    />
                </Box>
                <Box>
                    <h4 className={typography.headerTitle}>{t('cable.length')}</h4>
                    <Picker
                        data={cableOption}
                        options={[...lengthOptions]}
                        action={actionCreator.setActiveCableLength}
                        currentOption={currentLengthOption}
                    />
                </Box>
            </>
        );
    } else if (isError) {
        content = <div>{error.toString()}</div>;
    }
    return (
        <Box className={layout.excerptContainer} style={{ textAlign: 'center' }}>
            {content}
        </Box>
    );
};
